import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '@/lib/auth-store'
import { AppLayout } from '@/components/AppLayout'

export const Route = createFileRoute('/cancellations')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: CancellationsLayout,
})

function CancellationsLayout() {
  return (
    <AppLayout title="Cancellations">
      <Outlet />
    </AppLayout>
  )
}
